import {CardsProps} from "./types";
import {Card} from "../card/component";
import {FormattedMessage} from "react-intl";
import {Paginator} from "../paginator";
import Placeholder from "@ui-components/Placeholder";


export const CardsContainer = ({
  loading,
  surveys,
  colors,
  totalSurveys,
  pageSize,
  page,
  setPage,
  filters,
  cardExtraFields,
  cardActions,
  hideAuthor = false,
}: CardsProps) => {

  const content = loading
    ? Array.from({length: pageSize}, (_, idx) => (
      <Placeholder key={idx} height="h-80" />
    ))
    : surveys.map((s, idx) => (
      <Card
        key={idx}
        survey={s}
        colors={colors}
        actions={cardActions(s)}
        extraFields={cardExtraFields}
        hideAuthor={hideAuthor}
      />
    ));

  return (
    <div className={"flex flex-col bg-gray-100 gap-4 px-4 py-3"}>
      {filters}
      {(loading || surveys.length > 0) && <>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          {content}
        </div>
        <Paginator
          pageSize={pageSize}
          currentPage={page}
          totalItems={totalSurveys}
          setPage={setPage}
        />
      </>}
      {!loading && surveys.length === 0 && (
        <div className="flex flex-col items-center justify-center h-96">
          <FormattedMessage
            id={"no_results"}
            defaultMessage={"Nessun risultato"}
          />
        </div>
      )}
    </div>
  )
}